//Paquetes NPM de GYF.
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';

import GlobalHelper from '../../../Common/Helpers/GlobalHelper';
import AxiosManager from '../../../Common/Managers/AxiosManager';
import GetApiUrlsHelper from '../../../Common/Helpers/GetApiUrlsHelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

// ACTION TYPES
export const CARGA_INICIAL_PROCESOS = 'CARGA_INICIAL_PROCESOS';
export const GET_PROCESOS = 'GET_PROCESOS';
export const SELECCIONAR_FILTRO_PROCESOS = 'SELECCIONAR_FILTRO_PROCESOS';
export const FILTRAR_PROCESOS = 'FILTRAR_PROCESOS';
export const GET_TRAZA_PROCESOS = 'GET_TRAZA_PROCESOS';
export const APLICAR_FILTROS_EJECUCIONES = 'APLICAR_FILTROS_EJECUCIONES';
export const UP_GET_SSIS_CALENDARIO_PROCESO_Agenda = 'UP_GET_SSIS_CALENDARIO_PROCESO_Agenda';
export const UP_GET_SSIS_PROCESO_Datos_Ejecucion = 'UP_GET_SSIS_PROCESO_Datos_Ejecucion';
export const AD17P_GET_LOG_PROCESO = 'AD17P_GET_LOG_PROCESO';
export const SELECCION_COMBO_EJECUCION_DEMANDA = 'SELECCION_COMBO_EJECUCION_DEMANDA';
export const GET_ERRORES_PROCESO = 'GET_ERRORES_PROCESO';
export const CHECK_ERROR_PROCESOS = 'CHECK_ERROR_PROCESOS';
export const CHECK_ALL_ERROR_PROCESOS = 'CHECK_ALL_ERROR_PROCESOS';
export const MOSTRAR_MODAL = 'MOSTRAR_MODAL';
export const PROCESOS_MOSTRAR_MODAL_MENSAJE_RESULTADO = "PROCESOS_MOSTRAR_MODAL_MENSAJE_RESULTADO";
export const PROCESOS_MOSTRAR_MODAL = "PROCESOS_MOSTRAR_MODAL";
export const RESET_STORE = 'RESET_STORE';
export const SELECCIONAR_TAB_ERROR = 'SELECCIONAR_TAB_ERROR';
export const CHECK_SIN_TILDAR = 'CHECK_SIN_TILDAR';
export const REPROCESO_FINALIZADO = 'REPROCESO_FINALIZADO';
export const LOADING_REPROCESO = 'LOADING_REPROCESO';
export const LOADING_EJEC_DEMANDA = 'LOADING_EJEC_DEMANDA';
export const MENSAJE_EJECUCIONDEMANDA = 'MENSAJE_EJECUCIONDEMANDA';
export const CARGAR_ARCHIVOS_EJEC_DEMANDA = 'CARGAR_ARCHIVOS_EJEC_DEMANDA';
export const ACTUALIZAR_DATEPICKER = 'ACTUALIZAR_DATEPICKER';
export const ERROR_FOMARTO_FECHA = 'ERROR_FOMARTO_FECHA';
export const ERROR_FECHA_POSTERIOR = 'ERROR_FECHA_POSTERIOR';
export const LIMPIAR_TABLERO = 'LIMPIAR_TABLERO';
export const GET_ID_PROCESAMIENTO = 'GET_ID_PROCESAMIENTO';
export const ID_PROCESAMIENTO_SELECCIONADO = 'ID_PROCESAMIENTO_SELECCIONADO';
export const ERROR_FORMATO_ID_PROCESO = 'ERROR_FORMATO_ID_PROCESO';
export const LOADING_TABLERO = 'LOADING_TABLERO'; //Loading Spinner General para la funcionalidad
//PROCESOS_FILTRADOS_EJEC_DEMANDA: Se guarda un array con los procesos filtrados del DS UP_GET_LISTA_PROCESOS_EJECUCION_DEMANDA
export const PROCESOS_FILTRADOS_EJEC_DEMANDA = 'PROCESOS_FILTRADOS_EJEC_DEMANDA';
//VALOR_ACTUAL_COMBOS_EJEC_DEMANDA: Se guarda los valores actuales de los combos "Marca" y "Tipo de Proceso" del modal de Ejecución a Demanda.
export const VALOR_ACTUAL_COMBOS_EJEC_DEMANDA = 'VALOR_ACTUAL_COMBOS_EJEC_DEMANDA';
export const GET_CANTIDAD_PROCESOS = 'GET_CANTIDAD_PROCESOS';
export const AGREGAR_ARCHIVO_EJECUCION_DEMANDA = 'AGREGAR_ARCHIVO_EJECUCION_DEMANDA';
export const ERROR_EJECUCIONDEMANDA = 'ERROR_EJECUCIONDEMANDA';
export const SET_BUSQUEDA_ARCHIVOS = 'SET_BUSQUEDA_ARCHIVOS';
export const ES_EJECUCION_DEMANDA = 'ES_EJECUCION_DEMANDA';

let _dispatch = null;
let ProcesoTrazaID = '';
let jobAsociado = '';
let stateProceso;
let archivoEjecDemandaSeleccionado = '';
let idProceso = 0;

export function validarProcesoEnEjecucion(esReproceso) {
    return (dispatch, getState) => {
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_PROCESOS_EN_EJECUCION', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
        LogHelper.Out(validarProcesoEnEjecucion.name, null, 'GET_PROCESOS_EN_EJECUCION', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');

        Engine1Proxy.Execute((data) => _validarProcesoEnEjecucionCallback(data, esReproceso, dispatch, getState), null, null, 'PROCESOS');
    };
}

function _validarProcesoEnEjecucionCallback(data, esReproceso, dispatch, getState) {
    let estadoProcesos = JSON.parse(data.GET_PROCESOS_EN_EJECUCION).Recordset0.Rows;

    if (estadoProcesos && estadoProcesos.length > 0 && estadoProcesos[0].EstadoProceso != 0)
        _dispatch({ type: MOSTRAR_MODAL, modalId: 5, abrirCerrar: true, nombreProceso: estadoProcesos[0].Descripcion, mensaje: undefined });
    else if (esReproceso) {
        if (ValidarMaxDiasReproceso(getState)) {
            RecorrerTabla(dispatch, getState);
        } else {
            _dispatch({ type: MOSTRAR_MODAL, modalId: 5, abrirCerrar: true, nombreProceso: undefined, mensaje: 'La ejecuci\xf3n super\xf3 el plazo m\xe1ximo de d\xedas para Reprocesamiento.' });
        }
    }
    else {
        //Cargo loading
        _dispatch({ type: LOADING_EJEC_DEMANDA, valor: true });

        //Cargo en la tabla SSIS_ARCHIVOS los nombres de los archivos a ejecutar a demanda
        let param = {
            NOMBRE_JOMB: 'SSIS_Obtencion_Archivos_Ejec_Demanda',
        };
        Engine1Proxy.AddDataSourcesRequests(param, 'EXECUTE_JOB', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
        Engine1Proxy.Execute();

        //Obtengo los nombres de los archivos disponibles a ejecutar a demanda
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_ARCHIVOS_EJEC_DEMANDA', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
        Engine1Proxy.AddDataSourcesRequests(null, 'UP_GET_LISTA_PROCESOS_EJECUCION_DEMANDA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
        Engine1Proxy.Execute((data) => _callbackMostrarArchivos(data), null, null, 'PROCESOS');
    }
}

function _callbackMostrarArchivos(data) {
    let archivosEjecDemanda = JSON.parse(data.GET_ARCHIVOS_EJEC_DEMANDA).Recordset0.Rows;
    let procesosActivos = JSON.parse(data.UP_GET_LISTA_PROCESOS_EJECUCION_DEMANDA).Recordset0.Rows;

    _dispatch({ type: CARGAR_ARCHIVOS_EJEC_DEMANDA, archivosEjecDemanda: archivosEjecDemanda });
    _dispatch({ type: PROCESOS_FILTRADOS_EJEC_DEMANDA, procesos: procesosActivos })
    _dispatch({ type: VALOR_ACTUAL_COMBOS_EJEC_DEMANDA, valorCombos: undefined });
    _dispatch({ type: MOSTRAR_MODAL, modalId: 2, abrirCerrar: true });
    _dispatch({ type: ES_EJECUCION_DEMANDA, valor: true });
    _dispatch({ type: LOADING_EJEC_DEMANDA, valor: false });
}

//////////////////////////////////// INICIO REPROCESO ////////////////////////////////////
function ValidarMaxDiasReproceso(getState) {
    let stateProceso = getState().procesos;
    let fechaActual = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0);
    let cantDiasHabilReproc = [];

    //Se toma la fechaInicio del registro original como punto de partida para validar la cantidad m�xima de d�as para Reprocesamiento
    let fechaProceso = new Date(stateProceso.datosProcesos[0].FechaProceso);
    fechaProceso = new Date(fechaProceso.getFullYear(), fechaProceso.getMonth(), fechaProceso.getDate(), 0, 0, 0, 0);

    //Obtengo nombre del proceso
    let nombreProceso = stateProceso.labelErrorActiva;

    //Obtengo un array con la Cantidad M�xima de d�as H�biles para Reprocesamiento de todos los procesos parametrizados
    let arrayCantDiasHabilReproc = stateProceso.procesos;


    //Busco el dato de Cantidad m�xima de d�as H�biles de Reprocesamiento del proceso correspondiente
    cantDiasHabilReproc = arrayCantDiasHabilReproc.filter(x => x.NombreProceso == nombreProceso);


    //Recorro d�a por d�a (max: cantDiasHabilReproc) viendo que se tomen solo los d�as h�biles (ni sabado ni domingo ni feriados)
    //hasta obtener la fecha final
    let fechaFinal = fechaProceso;

    //Guardo la cantidad de d�as h�biles para Reprocesamiento
    let cantDiasTopeReproceso = cantDiasHabilReproc[0].CantidadDiasHabilesReproceso;

    fechaFinal = new Date(calcularDiasHabiles(fechaFinal, cantDiasTopeReproceso, getState));

    //Si la fecha actual es mayor o igual a la fecha final obtenida, entonces no se super� la cantidad m�xima de d�as, por lo que se puede continuar con el Reproceso.
    //Caso contrario se muestra un Modal con el mensaje de se super� la cantidad de d�as m�ximos para Reprocesamiento.
    if (fechaActual <= fechaFinal) {
        return true;
    } else {
        return false;
    }
}


//Funci�n que toma una fecha y recorre {cantDiasHabiles} d�as h�biles y retorna la fecha final
//Parametros

//1er Param: fecha (Date) - Fecha a partir de la cual se comienza el calculo
//2do Param: cantDiasHabiles (entero) - Cantidad de d�as h�biles a calcular
//3er Param: state (state) - Estado que contiene un array de feriados obtenido del DS GET_FERIADOS
function calcularDiasHabiles(fecha, cantDiasHabiles, state) {
    let fechaFinalString = "";
    let cantDias = 0;
    let esHabil = true;
    let fechaActual = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0);
    let fechasFeriados = [];
    let stateProceso = state().procesos;
    let fechaAux = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), 0, 0, 0, 0);
    let feriadoEncontrado = undefined;

    //Obtengo un array con todos los feriados parametrizados en ATLAS_FERIADO (DS: GET_FERIADOS) y que est�n activos
    let arrayFeriados = stateProceso.feriados.filter(feriado => feriado.ActivoFeriado);

    //Guardo solo las fechas de los feriados parametrizados
    fechasFeriados = arrayFeriados.map(feriado => new Date(feriado.FechaFeriado.toString()));

    //Obtengo los feriados correspondientes al a�o actual
    let feriadosActuales = fechasFeriados.filter(feriadoAnioActual => feriadoAnioActual.getFullYear() == fechaActual.getFullYear());


    //Comienzo a partir del d�a siguiente a contar
    fechaAux.setDate(fechaAux.getDate() + 1);

    while (cantDiasHabiles > 0) {
        //Si el d�a la fecha actual es S�bado, lo traslado al lunes
        if (fechaAux.getDay() == 6) {
            fechaAux.setDate(fechaAux.getDate() + 2);
            cantDias += 2;
            esHabil = false;
        }

        //Si el d�a la fecha actual es Domingo, lo traslado al lunes
        if (fechaAux.getDay() == 0) {
            fechaAux.setDate(fechaAux.getDate() + 1);
            cantDias += 1;
            esHabil = false;
        }

        //Armo el string de la fecha actual para compararlo
        fechaFinalString = fechaAux.getFullYear() + "-" + fechaAux.getMonth() + "-" + fechaAux.getDate();

        //Reviso si la fecha actual donde estoy parado es feriado o no
        feriadoEncontrado = feriadosActuales.find(feriado => feriado.getFullYear() + "-" + feriado.getMonth() + "-" + feriado.getDate() == fechaFinalString);

        //Si es feriado, traslado la fecha un d�a posterior
        if (feriadoEncontrado) {
            fechaAux.setDate(fechaAux.getDate() + 1);
            cantDias += 1;
            esHabil = false;
        }

        //Si hubo un traslado de fecha (la fecha con la que se empez� el calculo) no era h�bil, se vuelve a buclar ya que hay que considerar
        //que la fecha pr�xima h�bil en la que estoy parado no sea feriado.
        //Si la fecha en la que estoy parado es h�bil, entonces traslado la fecha un d�a m�s (hasta la m�xima cantidad de d�as h�biles parametrizada)
        //y resto una vuelta al bucle
        if (esHabil) {
            fechaAux.setDate(fechaAux.getDate() + 1);
            cantDias += 1;
            cantDiasHabiles -= 1;
        }

        esHabil = true;
    }

    return fecha.setDate(fecha.getDate() + cantDias);
}

export function RecorrerTabla(dispatch, getState) {
    let checkSinTildarDesestimar = 5;
    let checkSinTildarReprocesar = 5;
    let checkSinTildar = false;
    let i = 2,
        z = 0;
    let indexReproceso = '';

    _dispatch = dispatch;
    let stateP = getState();
    stateProceso = getState().procesos;

    for (i = 2; i < $('input:checkbox').length; i++) {
        if (i % 2 == 0) {
            checkSinTildarDesestimar = Number($('input:checkbox')[i].checked);
        } else {
            checkSinTildarReprocesar = Number($('input:checkbox')[i].checked);
            z++;
        }

        if (i % 2 != 0 && Number($('input:checkbox')[i].checked) == 1) {
            if (indexReproceso == '') indexReproceso = z.toString();
            else indexReproceso = indexReproceso.toString() + '|' + z.toString();
        }

        if (checkSinTildarDesestimar < 2 && checkSinTildarReprocesar < 2 && i % 2 != 0) {
            if (checkSinTildarDesestimar == 0 && checkSinTildarReprocesar == 0) {
                checkSinTildar = true;
                break;
            }
        }
    }
    /**
     * ADT-1220
     * Adintar17 - Tablero de ejecuciones: No se reprocesa correctamente el archivo cuando se desestiman los registros
     * Segun lo hablado con Silvia Serra, para reprocesar, se debe por lo menos seleccionar un registro para reprocesar,
     * si desestima todo debe mostrar una advertencia indicando que por lo menos debe seleccionar un registro a reprocesar
     * para efectuar la accion de Reprocesar
     */
    if (indexReproceso == '') {
        _dispatch({ type: MOSTRAR_MODAL, modalId: 6, mostrar: true, titulo: 'Atención', mensaje: 'Debe seleccionar al menos un registro para reprocesar.' });
    } else {
        _dispatch({ type: CHECK_SIN_TILDAR, checkSinTildar });
        if (!checkSinTildar) {
            _dispatch({ type: LOADING_REPROCESO, valor: true });

            if (indexReproceso && indexReproceso != '') {
                let erroresProcesosFiltrados = stateP.procesos.listaRowIdConError;
                let rowId = '';
                let index = indexReproceso.split('|');
                let nombreLabelDetalle = stateP.procesos.labelErrorActiva;
                ProcesoTrazaID = stateP.procesos.erroresProceso[0].ProcesoTrazaId;

                for (let a = 0; a < indexReproceso.split('|').length; a++) {
                    if (rowId == '') rowId = erroresProcesosFiltrados[index[a] - 1].RowId.toString();
                    else rowId = rowId + '|' + erroresProcesosFiltrados[index[a] - 1].RowId.toString();
                }

                let param = {
                    METODO: 0,
                    NOMBRE_LABEL_DETALLE: nombreLabelDetalle,
                    PROCESO_TRAZA_ID: ProcesoTrazaID,
                    ID: indexReproceso,
                    ROW_ID: rowId,
                };
                Engine1Proxy.AddRuleRequests(param, 'TABLEROPROCESOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
                Engine1Proxy.Execute((data) => _callBackLlamarDtsx(data, stateP, ProcesoTrazaID), null, null, 'CONSULTASOCIOS');
            } else {
                _dispatch({ type: LOADING_REPROCESO, valor: false });
            }
        }
    }
}

function _callBackLlamarDtsx(data, stateP, ProcesoTrazaID) {
    if (stateP.procesos.erroresProceso.length > 0) {
        jobAsociado = JSON.parse(data.TABLEROPROCESOS);
        let IDTraza = stateP.procesos.erroresProceso[0].ProcesoTrazaId;

        let param = {
            METODO: 1,
            PROCESO_TRAZA_ID: ProcesoTrazaID,
            NOMBRE_JOMB: jobAsociado,
            ID_TRAZA: IDTraza,
        };
        SagasProxy.AddSagaRequests(param, 'EXECUTE_JOB_REPROCESO', 'TARJETAS', 'ADMINPRODUCTOS');

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(SagasHelper.GetSagasId, undefined, GetEstadoReproceso, 'ADMINPRODUCTOS');
    }
}

function GetEstadoReproceso() {
    console.log('--------------------------------------------Inicio de la funcion GetEstadoProceso--------------------------------------------');

    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PROCESOS_EN_EJECUCION', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
    LogHelper.Out(validarProcesoEnEjecucion.name, null, 'GET_PROCESOS_EN_EJECUCION', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');
    Engine1Proxy.Execute((data) => _ValidarEstadoReprocesoCallBack(data), null, null, 'PROCESOS');

    console.log('--------------------------------------------Fin de la funcion GetEstadoProceso--------------------------------------------');
}

function _ValidarEstadoReprocesoCallBack(data) {
    let estadoProceso = JSON.parse(data.GET_PROCESOS_EN_EJECUCION).Recordset0.Rows;
    if (estadoProceso && estadoProceso.length > 0) {
        if (estadoProceso[0].EstadoProceso == 3) ReprocesoFinalizado();
        else GetEstadoReproceso();
    } else GetEstadoReproceso();
}

function ReprocesoFinalizado() {
    let reprocesoFinalizado = true;
    _dispatch({ type: REPROCESO_FINALIZADO, reprocesoFinalizado });
    _dispatch({ type: ACTUALIZAR_DATEPICKER, actualizarDatePicker: true, fecha: new Date() });
    _dispatch({ type: GET_ERRORES_PROCESO, errores: null, mostrarTablero: true });
    ActualizarProcesos();
    _dispatch({ type: LOADING_REPROCESO, valor: false });
}

//////////////////////////////////// FIN REPROCESO ////////////////////////////////////

//////////////////////////////////// INICIO EJECUCIÓN A DEMANDA ////////////////////////////////////

//Metodo que se llama cuando se presiona el boton de ejecutar a demanda
export function ejecutarDtsx(esAjustesCargosUala, esProcesoLaPampa) {
    LogHelper.In(ejecutarDtsx.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        stateProceso = getState();
        stateProceso = stateProceso.procesos;

        if (esAjustesCargosUala) { //Caso que se ejectue el proceso de Ajustes y Cargos Uala
            if (stateProceso.procesoEjecucion) {
                stateProceso.procesos.map((proc) => {
                    if (proc.DescripcionProceso == stateProceso.procesoEjecucion) {
                        jobAsociado = proc.JobAsociado? proc.JobAsociado : "" ;
                    }
                });
            }
            let idProcesamientoSeleccionado = stateProceso.idProcesamientoSeleccionado;

            if (idProcesamientoSeleccionado && idProcesamientoSeleccionado != 0) {
                _dispatch({ type: LOADING_EJEC_DEMANDA, valor: true });

                let param = {
                    NombreJob: jobAsociado,
                    GeneracionTrazaId: idProcesamientoSeleccionado,
                };

                Engine1Proxy.AddDataSourcesRequests(param, 'ACTUALIZA_PARAMETRO_SSIS_CORE_AJUCAR_OUT', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
                LogHelper.Out(ejecutarJob.name, param, 'ACTUALIZA_PARAMETRO_SSIS_CORE_AJUCAR_OUT', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');
                Engine1Proxy.Execute(() => ejecutarJob(), null, null, 'PROCESOS');
            } else {
                _dispatch({ type: ERROR_FORMATO_ID_PROCESO, valor: true });
            }

        } else if (esProcesoLaPampa) {
            _dispatch({ type: LOADING_EJEC_DEMANDA, valor: true });
            if (stateProceso.procesoEjecucion) {
                stateProceso.procesos.map((proc) => {
                    if (proc.DescripcionProceso == stateProceso.procesoEjecucion) {
                        jobAsociado = proc.JobAsociado? proc.JobAsociado : "" ;
                    }
                });
            }
            ejecutarJob();
        } else {
            if (stateProceso.archivoEjecDemandaSeleccionado.NombreArchivo == undefined || stateProceso.archivoEjecDemandaSeleccionado.NombreArchivo == '') {
                _dispatch({ type: MENSAJE_EJECUCIONDEMANDA, mensaje: 'Debe seleccionar algún archivo.' });
            } else if (stateProceso.procesoEjecucion == undefined || stateProceso.procesoEjecucion == '0') {
                _dispatch({ type: MENSAJE_EJECUCIONDEMANDA, mensaje: 'Debe seleccionar el Proceso a ejecutar.' });
            } else {
                _dispatch({ type: MENSAJE_EJECUCIONDEMANDA, mensaje: 'Dependiendo del tamaño del archivo este proceso puede demorar.' });
                //Cargo loading
                _dispatch({ type: LOADING_EJEC_DEMANDA, valor: true });

                //Obtengo el nombre del job a ejecutar
                if (stateProceso.procesoEjecucion) {
                    stateProceso.procesos.map((proc) => {
                        if (proc.DescripcionProceso == stateProceso.procesoEjecucion) {
                            jobAsociado = proc.JobAsociado? proc.JobAsociado : "" ;
                        }
                    });
                }

                if (jobAsociado == undefined || jobAsociado == '') {
                    _dispatch({ type: MENSAJE_EJECUCIONDEMANDA, mensaje: 'No se encontró un job asociado al proceso seleccionado, revisar la parametría del proceso elegido.' });
                    _dispatch({ type: LOADING_EJEC_DEMANDA, valor: false });
                } else {
                    let param = {
                        NombreJob: jobAsociado,
                        NombreArchivo: stateProceso.archivoEjecDemandaSeleccionado.NombreArchivo,
                    };

                    Engine1Proxy.AddDataSourcesRequests(param, 'ACTUALIZA_PARAMETRO_SSIS', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
                    LogHelper.Out(ejecutarJob.name, param, 'ACTUALIZA_PARAMETRO_SSIS', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');
                    Engine1Proxy.Execute(() => ejecutarJob(), null, null, 'PROCESOS');
                }
            }
        }
    };
}

function _getFecha() {
    let date = new Date();
    let dia = date.getDate();
    let mes = date.getMonth() + 1;
    let anio = date.getFullYear();
    let fecha;
    if (mes < 10) {
        fecha = `${dia}-0${mes}-${anio}`;
    } else {
        fecha = `${dia}-${mes}-${anio}`;
    }

    return new Date(fecha.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
}

function ejecutarJob() {
    let param = {
        NOMBRE_JOMB: jobAsociado,
    };
    Engine1Proxy.AddDataSourcesRequests(param, 'EXECUTE_JOB', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
    LogHelper.Out(ejecutarJob.name, param, 'EXECUTE_JOB', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');
    Engine1Proxy.Execute((data) => GetEstadoProceso(data), null, null, 'PROCESOS');
}

function GetEstadoProceso(data) {
    let resultado = ""
    if(data){
    resultado = JSON.parse(data.EXECUTE_JOB)?.Recordset0?.Rows[0];
    }
    if(data && resultado.MensajeError) {
        _dispatch({ type: MENSAJE_EJECUCIONDEMANDA, mensaje: resultado.MensajeError });
        _dispatch({ type: LOADING_EJEC_DEMANDA, valor: false });
    } else {
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_PROCESOS_EN_EJECUCION', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
        LogHelper.Out(GetEstadoProceso.name, null, 'GET_PROCESOS_EN_EJECUCION', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');
        Engine1Proxy.Execute((data) => ValidarEstadoProceso(data), null, null, 'PROCESOS');
    }
}

function ValidarEstadoProceso(data) {
    let estadoProceso = JSON.parse(data.GET_PROCESOS_EN_EJECUCION).Recordset0.Rows;
    if (estadoProceso && estadoProceso.length > 0) {
        if (estadoProceso[0].EstadoProceso == 3) _DtsxFinalizado();
        else GetEstadoProceso();
    } else GetEstadoProceso();
}

function _DtsxFinalizado() {
    archivoEjecDemandaSeleccionado = '';
    _dispatch({ type: LOADING_EJEC_DEMANDA, valor: false });
    _dispatch({ type: MENSAJE_EJECUCIONDEMANDA, mensaje: '' });
    _dispatch({ type: SELECCION_COMBO_EJECUCION_DEMANDA, campo: 'tipoProcesoEjecucion', valor: '0' });
    _dispatch({ type: SELECCION_COMBO_EJECUCION_DEMANDA, campo: 'procesoEjecucion', valor: '0' });
    _dispatch({ type: SELECCION_COMBO_EJECUCION_DEMANDA, campo: 'marcaIdEjecucion', valor: '0' });
    _dispatch({ type: VALOR_ACTUAL_COMBOS_EJEC_DEMANDA, valorCombos: undefined });
    _dispatch({ type: MOSTRAR_MODAL, modalId: 2, abrirCerrar: false });
    ActualizarProcesos();
}

//Actualiza los procesos en pantalla
function ActualizarProcesos() {
    let administradoras = stateProceso.administradoras;
    let fecha;

    if (typeof (stateProceso.fecha) == 'string' && stateProceso.fecha.length == 10) {
        let anio = stateProceso.fecha.substring(6, 10);
        let mes = stateProceso.fecha.substring(3, 5);
        let dia = stateProceso.fecha.substring(0, 2);

        fecha = new Date(anio, parseInt(mes) - 1, dia);
    } else {
        fecha = new Date();
    }

    fecha = fecha.toLocaleDateString();
    fecha = GlobalHelper.ConvertirFecha(fecha);


    let params = {
        MARCA_ID: null,
        FECHA: fecha,
    };

    Engine1Proxy.AddDataSourcesRequests(params, 'UP_GET_SSIS_PROCESO_TRAZA_PROCESOS_EJECUTADOS', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
    LogHelper.Out(cargaInicial.name, params, 'UP_GET_SSIS_PROCESO_TRAZA_PROCESOS_EJECUTADOS', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Socios');
    
    Engine1Proxy.AddDataSourcesRequests(params, 'GET_PROCESOS_PROGRAMADOS_EJECUTADOS', "Get", 'Tarjetas', 'PROCESOS', null, "Product", true);
    LogHelper.Out(cargaInicial.name, params, 'GET_PROCESOS_PROGRAMADOS_EJECUTADOS', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');

    Engine1Proxy.Execute((data) => _getTrazaProcesosCallback(data), null, null, 'PROCESOS');
}

////////////////////////////////////  FIN EJECUCIÓN A DEMANDA ////////////////////////////////////

/**
 * Action que obtiene el estado inicial y permisos.
 *  * @param {any} currentScope
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        var currentScopeRequest = {
            UserId: currentScope.UserId,
            ProductCode: currentScope.ProductCode,
            ProgramCode: currentScope.ProgramCode,
        };
        _dispatch({ type: LOADING_EJEC_DEMANDA, valor: true });
        stateProceso = getState().procesos;
        //TO DO MODIFICAR CUANDO SE DEFINAN PERMISOS, POR AHORA LLAMA DIRECTAMENTE A LA FUNCION QUE HACE LA CARGA INICIAL DE DATOS
        // ConciergeProxy.Execute((data) => _loadClientViewFunctions(data), null, "GETFUNCTIONS", currentScopeRequest);
        cargaInicial(); // función que debería llamarse después de verificar los permisos
    };
}

/**
 * Carga las funciones de seguridad
 * @param {any} data
 */
function _loadClientViewFunctions(data) {
    //TO DO MODIFICAR CUANDO SE DEFINAN PERMISOS
    LogHelper.In(_loadClientViewFunctions.name, data);

    //userFeatures = JSON.parse(JSON.stringify(data));

    let consultaSociosFunctions = JSON.parse(JSON.stringify(data.CONSULTASOCIOS));
    let consultaSociosFunctionsAllowed = [];
    let deliveryFunctions = undefined;
    let deliveryFunctionsAllowed = [];
    let solicitudFunctions = undefined;
    let solicitudFunctionsAllowed = [];

    consultaSociosFunctions.forEach((p) => {
        consultaSociosFunctionsAllowed[p.Codigo_Funcion] = true;
    });
    /*Se valida que el usuario tenga los permisos de delivery*/
    if (data.DELIVERY) {
        deliveryFunctions = JSON.parse(JSON.stringify(data.DELIVERY));
        deliveryFunctions.forEach((p) => {
            deliveryFunctionsAllowed[p.Codigo_Funcion] = true;
        });
    }
    /*Se valida que el usuario tenga los permisos de solicitudes*/
    if (data.SOLICITUD) {
        solicitudFunctions = JSON.parse(JSON.stringify(data.SOLICITUD));
        solicitudFunctions.forEach((p) => {
            solicitudFunctionsAllowed[p.Codigo_Funcion] = true;
        });
    }

    _dispatch({
        type: SET_USER_FUNCTIONS,
        consultaSociosFunctionsAllowed,
        solicitudFunctionsAllowed,
        deliveryFunctionsAllowed,
        userFeatures,
    });

    /*Si tiene permisos sobre la consulta de la pantalla, hago el resto de las llamadas*/
    if (consultaSociosFunctionsAllowed.Consulta == true) {
        //getIdCliente(data);
    }
}

/**
 * Action que llena los combos para filtrar y traer los procesos.
 */
function cargaInicial() {
    
    let fecha = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0);
    
    let param = {
        "MARCA_ID": null,
        "FECHA": fecha
    };

    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'Product', true);
    LogHelper.Out(cargaInicial.name, null, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'Product', true);

    Engine1Proxy.AddDataSourcesRequests(null, 'UP_GET_SSIS_PROCESO', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
    LogHelper.Out(cargaInicial.name, null, 'UP_GET_SSIS_PROCESO', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Socios');

    //Se agrega DS de obtenci�n de Feriados - ADT-1191
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_FERIADOS', "Get", 'Tarjetas', 'PROCESOS', null, "Product", true);
    LogHelper.Out(cargaInicial.name, null, 'GET_FERIADOS', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');

    Engine1Proxy.AddDataSourcesRequests(param, 'GET_PROCESOS_PROGRAMADOS_EJECUTADOS', "Get", 'Tarjetas', 'PROCESOS', null, "Product", true);
    LogHelper.Out(cargaInicial.name, null, 'GET_PROCESOS_PROGRAMADOS_EJECUTADOS', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');

    Engine1Proxy.Execute((data) => _cargaInicialCallback(data), null, null, "PROCESOS");


}

function _cargaInicialCallback(data) {
    let administradoras = JSON.parse(data.GET_ADMINISTRADORA).Recordset0.Rows;
    let procesos = JSON.parse(data.UP_GET_SSIS_PROCESO).Recordset0.Rows;
    let feriados = JSON.parse(data.GET_FERIADOS).Recordset0.Rows;
    let procesosProgramados = JSON.parse(data.GET_PROCESOS_PROGRAMADOS_EJECUTADOS).Recordset0.Rows;

    //solo corresponden los procesos de administradoras activas y procesos con AdministradoraId == null, correspondientes a procesos "genéricos"
    procesos = procesos.filter(pro => administradoras.some(ad => ad.Id == pro.AdministradoraId || pro.AdministradoraId == null));
    let resultado = { administradoras, procesos, feriados, procesosProgramados }
    _dispatch({ type: CARGA_INICIAL_PROCESOS, resultado });
    _dispatch({ type: LOADING_EJEC_DEMANDA, valor: false });

    stateProceso.procesos = procesos;
    stateProceso.administradoras = administradoras;
    ActualizarProcesos();
    //SI SOLO HAY UNA ADMINISTRADORA EL COMBO PARA FILTRAR POR MARCA NO VA A APARECER, POR LO QUE YA SE DEBE SELECCIONAR LA UNICA ADMINISTRADORA POSIBLE **ver ahora dicen que es bug**
    //if(administradoras.length == 1) _dispatch({ type: SELECCIONAR_FILTRO_PROCESOS,filtro:"marcaId", valor:administradoras[0].Id});
}

/**
 * Action que setea los filtros para traer los procesos.
 */
export function seleccionarFiltroProcesos(filtro, valor) {
    LogHelper.In(seleccionarFiltroProcesos.name, filtro, valor);

    return (dispatch, getState) => {
        if (validarFechaPosterior(valor)) dispatch({ type: ERROR_FECHA_POSTERIOR, campo: "esFechaPosterior", valor: true });
        else if (valor == 'Fecha inválida') {
            dispatch({ type: ERROR_FOMARTO_FECHA, campo: "errorFormatoFecha", valor: true });
        } else {
            dispatch({ type: ERROR_FOMARTO_FECHA, campo: "errorFormatoFecha", valor: false });
            dispatch({ type: ERROR_FECHA_POSTERIOR, campo: "esFechaPosterior", valor: false });
            dispatch({ type: SELECCIONAR_FILTRO_PROCESOS, filtro, valor });

            if (filtro != 'fecha' && filtro != 'proceso') {
                //SE FILTRAN LAS OPCIONES A MOSTRAR EN EL COMBO PROCESO DE ACUERDO A MARCA Y TIPO DE PROCESO
                dispatch({ type: FILTRAR_PROCESOS, filtro, valor });
                //SE LIMPIA LA SELECCION DE PROCESO POR SI ESE TIPO O MARCA NO CORRESPONDE POR HABER SIDO FILTRADO
                dispatch({ type: SELECCIONAR_FILTRO_PROCESOS, filtro: 'proceso', valor: '0' });
            }
        }
    };
}

export function actualizarIDProcesamiento(filtro, valor) {
    LogHelper.In(actualizarIDProcesamiento.name, filtro, valor);

    return (dispatch, getState) => {
        let stateProcesos = getState().procesos;

        //Obtengo el ID del proceso 'Ajustes y Cargos masivos a Ualá'
        idProceso = stateProcesos.procesos && stateProcesos.procesos.length > 0 ?
            stateProcesos.procesos.filter(x => x.NombreProceso == "CORE_AJUCAR_OUT") : [];
        idProceso = idProceso && idProceso.length > 0 ? idProceso[0].Id : 0;

        let dia, mes, anio, fechaAux;
        _dispatch = dispatch;

        if (validarFechaPosterior(valor)) {
            dispatch({ type: ERROR_FECHA_POSTERIOR, campo: "esFechaPosteriorEjecDemanda", valor: true });
            _dispatch({ type: "GET_ID_PROCESAMIENTO", valor: [] });
        }
        else if (valor == 'Fecha inválida') {
            _dispatch({ type: "GET_ID_PROCESAMIENTO", valor: [] })
            dispatch({ type: ERROR_FOMARTO_FECHA, campo: "errorFormatoFechaEjecDemanda", valor: true });
        } else {
            _dispatch({ type: LOADING_EJEC_DEMANDA, valor: true });
            dispatch({ type: ERROR_FOMARTO_FECHA, campo: "errorFormatoFechaEjecDemanda", valor: false });
            dispatch({ type: ERROR_FECHA_POSTERIOR, campo: "esFechaPosteriorEjecDemanda", valor: false });
            _dispatch({ type: ERROR_FORMATO_ID_PROCESO, valor: false });

            fechaAux = valor.split("/");
            dia = parseInt(fechaAux[0]);
            mes = parseInt(fechaAux[1]) - 1;
            anio = parseInt(fechaAux[2]);

            let paramConsultaTraza = {
                'FECHA': new Date(anio, mes, dia),
                'ID_PROCESO': idProceso
            };

            //Se llama al DS que obtiene los ID de Procesamiento - #ADT-1733
            Engine1Proxy.AddDataSourcesRequests(paramConsultaTraza, 'GET_CONSULTA_TRAZA', "Get", 'Tarjetas', 'PROCESOS', null, "Product", true);
            LogHelper.Out(cargaInicial.name, null, 'GET_CONSULTA_TRAZA', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');

            Engine1Proxy.Execute((data) => _callBackGetIdsProcesamiento(data), null, null, 'PROCESOS');

        }
    };
}

function _callBackGetIdsProcesamiento(data) {
    let idsProcesamiento = JSON.parse(data.GET_CONSULTA_TRAZA).Recordset0.Rows;
    _dispatch({ type: "GET_ID_PROCESAMIENTO", valor: idsProcesamiento });
    _dispatch({ type: ID_PROCESAMIENTO_SELECCIONADO, valor: 0 });
    _dispatch({ type: LOADING_EJEC_DEMANDA, valor: false });
}

function validarFechaPosterior(fecha) {
    let localeDate = typeof (fecha) == 'object' ? fecha.toLocaleDateString() : fecha;
    let fechaAux = localeDate.split('/');
    let fechaFinal;
    let fechaPosterior;

    let dia = fechaAux[0];
    let mes = fechaAux[1];
    let anio = fechaAux[2];
    fechaAux = mes + '/' + dia + '/' + anio;

    fechaFinal = new Date(fechaAux);

    if (fechaFinal > new Date()) fechaPosterior = true;
    else fechaPosterior = false;

    return fechaPosterior;
}

/**
 * Action que según el parametro recibido vacía una variable del state para que no se superpongan los procesos en el tablero.
 */
export function limpiarTablero(seccion) {
    LogHelper.In(limpiarTablero.name, seccion);

    return (dispatch, getState) => {
        dispatch({ type: LIMPIAR_TABLERO, seccion });
    };
}

/**
 * Action que activa y desactiva los modales de la pantalla.
 */
export function mostrarModal(modalId, abrirCerrar) {
    LogHelper.In(modalId.name, modalId, abrirCerrar);

    return (dispatch, getState) => {
        dispatch({ type: MOSTRAR_MODAL, modalId, abrirCerrar });
    };
}

/**
 * Action que activa y desactiva los modales de la pantalla.
 */
export function resetStore() {
    LogHelper.In(resetStore.name);

    return (dispatch, getState) => {
        dispatch({ type: RESET_STORE });
    };
}

/**
 * Action que obtiene los procesos de acuerdo a los filtros aplicados.
 */
export function getTrazaProcesos(fecha, marcaId) {
    LogHelper.In(getTrazaProcesos.name, fecha, marcaId);

    return (dispatch, getState) => {
        _dispatch({ type: LIMPIAR_TABLERO, seccion: "CajasTablero" });

        let stateProcesos = getState().procesos;
        let administradoras = stateProcesos.administradoras;
        let MarcaId;
        let fechaAux = GlobalHelper.ConvertirFecha(fecha);

        switch (marcaId) {
            case '0':
                MarcaId = null;
                break;
            case '-1':
                MarcaId = 0;
                break;
            default:
                MarcaId = marcaId;
                break;
        }

        let params = {
            MARCA_ID: MarcaId,
            FECHA: fechaAux,
        };

        let paramProcesos = {
            MARCA_ID: MarcaId,
            FECHA: fechaAux
        };

        Engine1Proxy.AddDataSourcesRequests(params, 'UP_GET_SSIS_PROCESO_TRAZA_PROCESOS_EJECUTADOS', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
        LogHelper.Out(cargaInicial.name, params, 'UP_GET_SSIS_PROCESO_TRAZA_PROCESOS_EJECUTADOS', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Socios');

        Engine1Proxy.AddDataSourcesRequests(paramProcesos, 'GET_PROCESOS_PROGRAMADOS_EJECUTADOS', "Get", 'Tarjetas', 'PROCESOS', null, "Product", true);
        LogHelper.Out(cargaInicial.name, null, 'GET_PROCESOS_PROGRAMADOS_EJECUTADOS', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');

        Engine1Proxy.Execute((data) => _getTrazaProcesosCallback(data, marcaId), null, null, 'PROCESOS');
    };
}

function _getTrazaProcesosCallback(data, marcaId) {
    let ejecucionesProcesos = JSON.parse(data.UP_GET_SSIS_PROCESO_TRAZA_PROCESOS_EJECUTADOS).Recordset0.Rows;
    let procesosProgramados = JSON.parse(data.GET_PROCESOS_PROGRAMADOS_EJECUTADOS).Recordset0.Rows;

    ejecucionesProcesos = ejecucionesProcesos.reverse();

    ejecucionesProcesos.map((ejec) => {
        ejec.sumarDia = ejec.FechaProcesoFin ? GlobalHelper.CalcularDiferenciaDias(ejec.FechaProceso, ejec.FechaProcesoFin) : 0;
        ejec.HoraInicio = ejec.HoraInicio.split(' ')[1];
        ejec.HoraFin = ejec.HoraFin ? ejec.HoraFin.split(' ')[1] : '-';
    });

    _dispatch({ type: GET_CANTIDAD_PROCESOS, procesosProgramados });
    _dispatch({ type: GET_TRAZA_PROCESOS, ejecucionesProcesos });
    _dispatch({ type: APLICAR_FILTROS_EJECUCIONES, administradoraSeleccionada: marcaId });
}

/**
 * Action que obtiene los procesos documentados por administradora y fecha.
 */

export function getProcesosDocumentados(marcaId) {
    LogHelper.In(getProcesosDocumentados.name, marcaId);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        let estadoProcesos = getState();
        estadoProcesos = estadoProcesos.procesos;
        let fecha = GlobalHelper.ConvertirFecha(GlobalHelper.CheckDateType(estadoProcesos.fecha));
        let fechaAux = fecha.toLocaleDateString().split('/');
        fechaAux = fechaAux[1] + '/' + fechaAux[0] + '/' + fechaAux[2];

        let params = {
            ADMINISTRADORA_ID: marcaId,
            FECHA: fechaAux,
        };

        Engine1Proxy.AddDataSourcesRequests(params, 'UP_GET_SSIS_CALENDARIO_PROCESO_Agenda', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
        LogHelper.Out(getProcesosDocumentados.name, params, 'UP_GET_SSIS_CALENDARIO_PROCESO_Agenda', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Socios');

        _dispatch({ type: LOADING_TABLERO, loadingState: true });

        Engine1Proxy.Execute((data) => _getProcesosDocumentadosCallback(data), null, null, 'CONSULTASOCIOS');
    };
}

function _getProcesosDocumentadosCallback(data) {
    let procesosDocumentados = JSON.parse(data.UP_GET_SSIS_CALENDARIO_PROCESO_Agenda).Recordset0.Rows;
    _dispatch({ type: UP_GET_SSIS_CALENDARIO_PROCESO_Agenda, procesosDocumentados });
    _dispatch({ type: LOADING_TABLERO, loadingState: false });
    _dispatch({ type: MOSTRAR_MODAL, modalId: 1, abrirCerrar: true });
}

/**
 * Action que obtiene los datos de un proceso en particular para el modal que los muestra.
 */

export function getDatosProceso(procesoTrazaId) {
    LogHelper.In(getDatosProceso.name, procesoTrazaId);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let params = {
            PROCESO_TRAZA_ID: procesoTrazaId,
        };

        Engine1Proxy.AddDataSourcesRequests(params, 'UP_GET_SSIS_PROCESO_Datos_Ejecucion', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
        Engine1Proxy.AddDataSourcesRequests(params, 'AD17P_GET_LOG_PROCESO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
        LogHelper.Out(getProcesosDocumentados.name, params, 'UP_GET_SSIS_PROCESO_Datos_Ejecucion', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Socios');
        LogHelper.Out(getProcesosDocumentados.name, params, 'AD17P_GET_LOG_PROCESO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Socios');

        Engine1Proxy.Execute((data) => _getDatosProcesoCallback(data), null, null, 'CONSULTASOCIOS');
    };
}

function _getDatosProcesoCallback(data) {
    let datosProcesosEncabezado = JSON.parse(data.UP_GET_SSIS_PROCESO_Datos_Ejecucion).Recordset0.Rows;
    let datosProcesos = JSON.parse(data.UP_GET_SSIS_PROCESO_Datos_Ejecucion).Recordset1.Rows;
    let datosProceso = JSON.parse(data.AD17P_GET_LOG_PROCESO).Recordset1.Rows;

    datosProcesosEncabezado.map((ejec) => {
        ejec.sumarDia = ejec.FechaProcesoFin ? GlobalHelper.CalcularDiferenciaDias(ejec.FechaProceso, ejec.FechaProcesoFin) : 0;
        ejec.HoraInicio = ejec.FechaProceso.split('T')[1];
        ejec.HoraInicio = ejec.HoraInicio.slice(0, 5);
        ejec.HoraFin = ejec.FechaProcesoFin ? ejec.FechaProcesoFin.split('T')[1] : '-';
        ejec.HoraFin = ejec.HoraFin.slice(0, 5);
    });

    _dispatch({ type: UP_GET_SSIS_PROCESO_Datos_Ejecucion, datosProcesos, datosProcesosEncabezado });
    _dispatch({ type: AD17P_GET_LOG_PROCESO, datosProceso });
}

export function limpiarCombos() {
    return (dispatch, getState) => {
        _dispatch({ type: ES_EJECUCION_DEMANDA, valor: false });
        _dispatch({ type: SELECCION_COMBO_EJECUCION_DEMANDA, campo: 'marcaIdEjecucion', valor: '0' });
        _dispatch({ type: SELECCION_COMBO_EJECUCION_DEMANDA, campo: 'tipoProcesoEjecucion', valor: '0' });
        _dispatch({ type: SELECCION_COMBO_EJECUCION_DEMANDA, campo: 'procesoEjecucion', valor: '0' });
        _dispatch({ type: VALOR_ACTUAL_COMBOS_EJEC_DEMANDA, valorCombos: undefined });
        _dispatch({ type: MENSAJE_EJECUCIONDEMANDA, mensaje: '' });
        _dispatch({ type: MOSTRAR_MODAL, modalId: 2, abrirCerrar: false });
        _dispatch({ type: ERROR_EJECUCIONDEMANDA, errorEjecDemanda: false });
        _dispatch({ type: SET_BUSQUEDA_ARCHIVOS, textArchivo: ''});
        archivoEjecDemandaSeleccionado = '';
    };
}

export function seleccionComboEjecucionDemanda(campo, valor, administradoraId, tipoProceso) {
    valor = valor == "0" ? null : valor;

    _dispatch({ type: SET_BUSQUEDA_ARCHIVOS, textArchivo: ''});

    if (campo == 'marcaIdEjecucion' || campo == 'tipoProcesoEjecucion') {
        let valorCombos = {
            administradoraId: campo == 'marcaIdEjecucion' ? valor : administradoraId,
            tipoProceso: campo == 'tipoProcesoEjecucion' ? valor : tipoProceso
        }

        _dispatch({ type: VALOR_ACTUAL_COMBOS_EJEC_DEMANDA, valorCombos });
    }

    let paramSeleccionCombo = {
        ADMINISTRADORA_ID: campo == 'marcaIdEjecucion' ? valor : administradoraId,
        TIPO_PROCESO: campo == 'tipoProcesoEjecucion' ? valor : tipoProceso
    }

    Engine1Proxy.AddDataSourcesRequests(paramSeleccionCombo, 'UP_GET_LISTA_PROCESOS_EJECUCION_DEMANDA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
    Engine1Proxy.Execute((data) => _callBackseleccionComboEjecucionDemanda(data), null, null, 'PROCESOS');

    LogHelper.In(seleccionComboEjecucionDemanda.name, campo, valor);
    return (dispatch, getState) => {
        let stateProcesos = getState().procesos;

        //Obtengo el ID del proceso 'Ajustes y Cargos masivos a Ualá'
        idProceso = stateProcesos.procesos && stateProcesos.procesos.length > 0 ?
            stateProcesos.procesos.filter(x => x.NombreProceso == "CORE_AJUCAR_OUT") : [];
        idProceso = idProceso && idProceso.length > 0 ? idProceso[0].Id : 0;

        //En caso que se cumpla esta condición reinicio el select de "Procesos"
        if (campo == 'marcaIdEjecucion' || campo == 'tipoProcesoEjecucion') {
            _dispatch({ type: SELECCION_COMBO_EJECUCION_DEMANDA, campo: 'procesoEjecucion', valor: '0' });
            _dispatch({ type: LOADING_EJEC_DEMANDA, valor: true });
        }

        if (campo == "procesoEjecucion" && valor == idProceso) {
            _dispatch({ type: LOADING_EJEC_DEMANDA, valor: true });

            let fechaActual = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0);

            let paramConsultaTraza = {
                'FECHA': fechaActual,
                'ID_PROCESO': idProceso
            };

            //Se llama al DS que obtiene los ID de Procesamiento - #ADT-1733
            Engine1Proxy.AddDataSourcesRequests(paramConsultaTraza, 'GET_CONSULTA_TRAZA', "Get", 'Tarjetas', 'PROCESOS', null, "Product", true);
            LogHelper.Out(cargaInicial.name, null, 'GET_CONSULTA_TRAZA', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Product');

            Engine1Proxy.Execute((data) => _callBackGetIdsProcesamiento(data), null, null, 'PROCESOS');
        } else if (campo == "procesoEjecucion" && valor != idProceso) {
            _dispatch({ type: "GET_ID_PROCESAMIENTO", valor: [] });
            _dispatch({ type: ERROR_FORMATO_ID_PROCESO, valor: false });
        }

        _dispatch({ type: SELECCION_COMBO_EJECUCION_DEMANDA, campo, valor });

    };
}

function _callBackseleccionComboEjecucionDemanda(data) {
    let procesosActivosFiltrados = JSON.parse(data.UP_GET_LISTA_PROCESOS_EJECUCION_DEMANDA).Recordset0.Rows;

    _dispatch({ type: PROCESOS_FILTRADOS_EJEC_DEMANDA, procesos: procesosActivosFiltrados })
    _dispatch({ type: LOADING_EJEC_DEMANDA, valor: false });
}


export function seleccionIdProceso(id) {
    return (dispatch, getState) => {
        _dispatch = dispatch;

        if (id && id != 0)
            _dispatch({ type: ERROR_FORMATO_ID_PROCESO, valor: false });

        _dispatch({ type: ID_PROCESAMIENTO_SELECCIONADO, valor: id });
    };
}

export function seleccionArchivo(archivoEjecDemandaSeleccion, index) {
    return (dispatch, getState) => {
        _dispatch = dispatch;

        if (index == 0) {
            archivoEjecDemandaSeleccionado = '';
        } else {
            _dispatch({
                type: MENSAJE_EJECUCIONDEMANDA,
                mensaje: 'Dependiendo del tamaño del archivo este proceso puede demorar.',
            });
            archivoEjecDemandaSeleccionado = archivoEjecDemandaSeleccion;
        }
    };
}

export function getErroresProceso(procesoTrazaId, colorEstado) {
    LogHelper.In(getErroresProceso.name, procesoTrazaId);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        if (procesoTrazaId) {
            _dispatch({ type: LOADING_EJEC_DEMANDA, valor: true });
            let params = {
                PROCESO_TRAZA_ID: procesoTrazaId,
            };

            Engine1Proxy.AddDataSourcesRequests(params, 'UP_GET_SSIS_PROCESO_TRAZA_Registros_Error', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
            LogHelper.Out(getErroresProceso.name, params, 'UP_GET_SSIS_PROCESO_TRAZA_Registros_Error', 'Get', 'Tarjetas', 'PROCESOS', 1, 'Socios');

            Engine1Proxy.Execute((data) => _getErroresProcesoCallback(data, colorEstado), null, null, 'PROCESOS');
        } else {
            _dispatch({ type: GET_ERRORES_PROCESO, errores: null, mostrarTablero: true });
            dispatch({ type: MOSTRAR_MODAL, modalId: 3, abrirCerrar: true });
        }
    };
}

function _getErroresProcesoCallback(data, colorEstado) {
    let errores = JSON.parse(data.UP_GET_SSIS_PROCESO_TRAZA_Registros_Error);
    let objAux = {};
    let firstSetOfErrors = [];
    let nombres = [];
    let recordsets = [];
    let listaRowIdConError = [];

    //LA CANTIDAD DE RECORDSETS QUE VAN A LLEGAR ES VARIABLE, POR LO QUE PARA ITERAR SOBRE EL OBJETO DEBEN TOMARSE DE ESTA MANERA
    recordsets = Object.getOwnPropertyNames(errores);

    //LOS ERRORES DEBEN SEPARARSE POR "error.NombreLabelDetalle" PARA DESPLEGARLOS EN PESTAÑAS SEPARADAS
    recordsets.map((recordset) => {
        if (errores[recordset].Rows && errores[recordset].Rows.length > 0 && errores[recordset].Columns.length > 1) {
            let nombreAux = errores[recordset].Rows[0].NombreLabelDetalle;
            nombres.push(errores[recordset].Rows[0].NombreLabelDetalle);
            objAux[nombreAux] = errores[recordset].Rows;
        }
        if (errores[recordset].Columns.length == 1) {
            //Cargo los RowId para el reprocesamiento
            listaRowIdConError = errores[recordset].Rows;
        }
    });

    //SE TOMA UN PRIMER SET DE ERRORES PARA QUE SE DESPLIEGUE POR DEFECTO EN LA TABLA
    firstSetOfErrors = objAux[nombres[0]];
    _dispatch({ type: LOADING_EJEC_DEMANDA, valor: false });
    _dispatch({ type: GET_ERRORES_PROCESO, errores: firstSetOfErrors, erroresTotal: objAux, mostrarTablero: false, nombres, colorEstado: colorEstado, listaRowIdConError: listaRowIdConError });
}

export function checkError(rowId, accion) {
    LogHelper.In(checkError.name, rowId, accion);

    return (dispatch, getState) => {
        dispatch({ type: CHECK_ERROR_PROCESOS, rowId, accion });
    };
}

export function checkAllError(accion) {
    LogHelper.In(checkError.name, accion);

    return (dispatch, getState) => {
        dispatch({ type: CHECK_ALL_ERROR_PROCESOS, accion });
    };
}

/**
 *
 * ACTION SELECCIONAR LA PESTAÑA DE ERROR Y QUE ACTUALICE LA TABLA
 */
export function seleccionarTabError(label) {
    LogHelper.In(seleccionarTabError.name, label);

    return (dispatch, getState) => {
        let erroresSeleccionados = [];
        let state = getState();
        state = state.procesos;
        let errores = JSON.parse(JSON.stringify(state.erroresTotal));

        erroresSeleccionados = errores[label];

        dispatch({ type: CHECK_ALL_ERROR_PROCESOS, accion: false });
        dispatch({ type: SELECCIONAR_TAB_ERROR, erroresSeleccionados, label });
    };
}

/**
 * ADT-1220
 * Adintar17 - Tablero de ejecuciones: No se reprocesa correctamente el archivo cuando se desestiman los registros
 * Segun hablado con Silvia Serra para reprocesar, se debe por lo menos seleccionar un registro a reprocesar,
 * si desestima todo debe mostrar una advertencia indicando que por lo menos debe seleccionar un registro a reprocesar
 * para efectuar la accion de Reprocesar
 */
export function ocultarModalDatosCuenta() {
    LogHelper.In(ocultarModalDatosCuenta.name);

    return (dispatch, getState) => {
        dispatch({ type: MOSTRAR_MODAL, modalId: 6, mostrar: false, titulo: '', mensaje: '' });
    };
}


export function addArchivoEjecucionDemanda(archivo, errorArchivoEjecDemanda) {
    LogHelper.In(addArchivoEjecucionDemanda.name, archivo);

    return (dispatch, getState) => {
        _dispatch({ type: MENSAJE_EJECUCIONDEMANDA, mensaje: errorArchivoEjecDemanda });

        if(errorArchivoEjecDemanda)
            _dispatch({ type: ERROR_EJECUCIONDEMANDA, errorEjecDemanda: true });
        else
            _dispatch({ type: ERROR_EJECUCIONDEMANDA, errorEjecDemanda: false });

        _dispatch({ type: AGREGAR_ARCHIVO_EJECUCION_DEMANDA, archivo });
    }
}

export function setBusquedaArchivos(textArchivo) {
    LogHelper.In(setBusquedaArchivos.name, textArchivo);

    return (dispatch, getState) => {
        _dispatch({ type: SET_BUSQUEDA_ARCHIVOS, textArchivo});
    };
}

export function mostrarOcultarModal(nombreModal, mostrarModal) {
    LogHelper.In(mostrarOcultarModal.name, nombreModal, mostrarModal);

    return (dispatch) => {
        _dispatch({ type: PROCESOS_MOSTRAR_MODAL, nombreModal, mostrarModal });
        _dispatch({ type: LOADING_TABLERO, loadingState: false });
    };
}

export function DescargarExcelErroresYNotas(erroresProceso){
    return (dispatch) => {
        _dispatch({ type: LOADING_TABLERO, loadingState: true });

        let fechaActual = formatearFecha(new Date().toLocaleDateString('en-GB'));
        let nombreArchivo = fechaActual + "_TableroProcesos_ErroresYNotas.xlsx";
        let nombreHoja = "ErroresYNotas";
        let nombreReporte = "Errores y Notas";
        let headersDinamicos = [];
        let datosCombinados = [];

        let erroresProcesoFiltrados = erroresProceso.map(error => {
            let nuevoError = {};
            for (let key in error) {
                if (key !== 'rSpan' && key !== 'noCheck' && key !== 'reprocesar' && key !== 'desestimar') {
                    nuevoError[key] = error[key];
                }
            }
            return nuevoError;
        });

        if (erroresProcesoFiltrados && erroresProcesoFiltrados.length > 0) {
            headersDinamicos = Object.entries(erroresProcesoFiltrados[0]).map(([key, value]) => ({
                Name: key,
                Description: key,
                DataType: typeof value,
                Totalize: false,
                Sheet: 'ErroresYNotas'
            }));
    
        }

        datosCombinados = erroresProcesoFiltrados.map((error) => ({
            DynamicData: error
        }));

        let params = {
            FileConfigName: "ProcesosErroresNotas_Excel",
            ExcelBody: [
                {
                    SheetName: nombreHoja,
                    Content: {
                        ErroresYNotasContent: datosCombinados
                    }
                }
            ],
            FileName: nombreArchivo,
            ReportTitle: nombreReporte,
            HeadersDinamicos: headersDinamicos
        }

        AxiosManager.AxiosRequest('post', GetApiUrlsHelper.GetAxiosUrl('ExcelFile'), null, params, 'arraybuffer', _callbackFileDownload, _callbackMostrarMensajeError)
    };
}


export function descargarExcel(datosProceso, datosProcesosEncabezado) {
    return (dispatch) => {
        _dispatch({ type: LOADING_TABLERO, loadingState: true });

        let fechaActual = formatearFecha(new Date().toLocaleDateString('en-GB'));
        let nombreArchivo = fechaActual + "_dataProcesamiento.xlsx";
        let nombreHoja = "Tablero procesos";
        let nombreReporte = datosProcesosEncabezado.DescripcionProceso
        
        let params = {
            FileConfigName: "TableroProcesos_Excel",
            ExcelBody: [
                {
                    SheetName: nombreHoja,
                    Content: {
                        TableroProcesosContent: datosProceso
                    }
                }
            ],
            FileName: nombreArchivo,
            ReportTitle: nombreReporte
        }

        AxiosManager.AxiosRequest('post', GetApiUrlsHelper.GetAxiosUrl('ExcelFile'), null, params, 'arraybuffer', _callbackFileDownload, _callbackMostrarMensajeError)
    };
}

function _callbackFileDownload(response) {
    try {
        if(response) {
            const nombreArchivo = JSON.parse(response.config.data)?.FileName;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', nombreArchivo);
            document.body.appendChild(link);
            link.click();

            _dispatch({ type: LOADING_TABLERO, loadingState: false });
        }
    } catch (error) {
        _dispatch({ type: LOADING_TABLERO, loadingState: false });
        _dispatch({ type: PROCESOS_MOSTRAR_MODAL_MENSAJE_RESULTADO, mensaje: "Ocurrió un error al intentar descargar el archivo. Información: " + error, modalMensajeResultado});
    }
}

function _callbackMostrarMensajeError(response) {
    _dispatch({ type: LOADING_TABLERO, loadingState: true });
    _dispatch({ type: PROCESOS_MOSTRAR_MODAL_MENSAJE_RESULTADO, mensaje: "Ocurrió un error al intentar descargar el archivo. Información: " + response});
}

function formatearFecha(fecha) {
    let diaFecha = fecha.substring(0,2);
    let mesFecha = fecha.substring(3,5);
    let anioFecha = fecha.substring(6,10);

    return anioFecha + mesFecha + diaFecha;
}